export const getSortedReturnables = (sections) => {
	return sections.sort((a, b) => {
		if (a.isRemove === b.isRemove) {
			return 0;
		}
		return a.isRemove === 1 ? 1 : -1;
	});
};
